import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    id: 'studio.t1Iyem',
    defaultMessage: 'App definition',
  },
  description: {
    id: 'studio.wM/ueE',
    defaultMessage: 'The app definition for {appName}',
  },
  view: {
    id: 'studio.nevxi8',
    defaultMessage: 'View app',
  },
  cloneText: {
    id: 'studio.0Atfb1',
    defaultMessage:
      'Want to create a new app based on {name}? This app can be cloned by pressing the clone button.',
  },
  explanation: {
    id: 'studio.neh6MB',
    defaultMessage:
      'Apps are defined by their app definition. An app definition is a YAML file which describes what the app does and what it looks like.',
  },
  learnMore: {
    id: 'studio.TdTXXf',
    defaultMessage: 'Learn more',
  },
});
